import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { CopyToClipboard } from "react-copy-to-clipboard";
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';
import codeCode from './pic/copyCode.png'
import styles from "./apiList.less";

function StructExample({ respExampleData = {}, text = '' }) {
    const { example, exampleXml, exampleSoap1, exampleSoap2 } = respExampleData
    const jsonData = JSON.stringify(example, null, 4);
    const [codeContent, setcodeContent] = useState(jsonData);
    const [copySuccText, setcopySuccText] = useState('点击复制');
    const id = text === '请求结构示例' ? 'structexample_0' : 'structexample_1';
    const content = {
        JSON: jsonData,
        XML: exampleXml,
        SOAP1_1: exampleSoap1,
        SOAP1_2: exampleSoap2
    }
    /* 代码高亮 */
    useEffect(() => {
        document.querySelectorAll('pre code').forEach((el) => {
            hljs.highlightElement(el);
        })
    }, [codeContent])

    useEffect(() => {
        const timer = window.setTimeout(() => { setcopySuccText('点击复制') }, 1000);
        return () => {
            window.clearTimeout(timer);
        }
    }, [copySuccText])

    useEffect(() => {
        setcodeContent(jsonData)
    }, [jsonData])

    /* 切换json or xml */
    const handleClick = (e) => {
        const targetNode = e.target;
        const text = targetNode.innerText;
        const targetDivNode = targetNode.className === 'clickdiv' ? targetNode : targetNode.parentNode;
        const clickdivs = targetDivNode.parentNode.querySelectorAll('.clickdiv');
        clickdivs.forEach((item) => {
            const flag = item === targetDivNode;
            item.firstElementChild.className = flag ? styles.exampleHeadText_click : styles.exampleHeadText;
            item.lastElementChild.className = flag ? styles.exampleHeadBorder_click : styles.exampleHeadBorder;
        })
        setcodeContent(content[text])
    }

    /* 代码复制 */
    const copySucc = () => {
        setcopySuccText('复制成功');
    }

    return (
        <div id={id} className={`${styles.structexample} controledanchor`}>
            <h2>{text}</h2>
            <div className={styles.example}>
                <div className={styles.exampleHead} onClick={handleClick}>          
                    {Object.keys(content).map((item, index) => {
                        return (
                            <div className='clickdiv' key={item}>
                                <div className={index ? styles.exampleHeadText : styles.exampleHeadText_click}>{item}</div>
                                <div className={index ? styles.exampleHeadBorder : styles.exampleHeadBorder_click}></div>
                            </div>
                        )
                    })}
                </div>
                <div className={styles.exampleBody} style={{ display: `${(JSON.stringify(respExampleData) !== '{}') ? 'block' : 'none'}` }}>
                    <pre><code className={codeContent === jsonData ? "json" : "xml"}>{codeContent}</code></pre>
                    <CopyToClipboard className={styles.copytoclipboard} text={codeContent} onCopy={copySucc}><div><img src={codeCode}></img><span>{copySuccText}</span></div></CopyToClipboard>
                </div>
            </div>
        </div>
    )
}


StructExample.propTypes = {
    respExampleData: PropTypes.object,
    text: PropTypes.string
}

export default StructExample;